:host {
  display: block;

  div {
    margin-top: 20px;
    padding:0;
    width: 30px;
    height: 15px;
    padding: .95rem 1.3rem;
    background-color: transparent;
    border: transparent;
    transform: rotate(0deg);
    transition: .5s ease-in-out;
    cursor: pointer;
    z-index: 3;

    &:focus {
      outline: transparent;
    }

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 22px;
      background: #fff;
      opacity: 1;
      left: 0;
      transform: rotate(0deg);
      transition: .25s ease-in-out;
    }

     span:nth-child(1) {
      top: 6.5px;
    }

     span:nth-child(2), span:nth-child(3) {
      top: calc(6.5px + 6px);
    }
  }
  .open span:nth-child(1) {
    top: calc(6.5px + 6px);
  }

  .open span:nth-child(1) {
    transform: rotate(45deg);
  }

  .open span:nth-child(2) {
    transform: rotate(-45deg);
  }
}
